import React, { useState } from "react";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import { Typography } from "@mui/material";
import prImg1 from "../images/prImg1.jpg";
import prImg2 from "../images/prImg2.jpg";
import prImg3 from "../images/prImg3.jpg";
import prImg4 from "../images/prImg4.jpg";
import prImg5 from "../images/prImg5.jpg";
import prImg6 from "../images/prImg6.jpg";
import { Modal } from "@mui/material";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import Tooltip from "@mui/material/Tooltip";

const PhotoGallery = ({ role, userData }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [currentImg, setCurrentImg] = useState(null);
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const imgArr = [prImg1, prImg2, prImg3, prImg4, prImg5, prImg6];

  const openModal = (img) => {
    setCurrentImg(img);
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setCurrentImg(null);
  };

  return (
    <div>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-5 bg-white"></div>
      <div className="px-0 px-md-3">
        <div className="col-12 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="">{t("Photo Gallery")}</h5>
          </div>
        </div>
        {role !== 10 && (
          <form action="" className="mt-4">
            <div className="row">
              <div className="col-4">
                <label htmlFor="title" className="form-group">
                  Title
                </label>
                <input
                  type="text"
                  id="title"
                  className="form-control"
                />
              </div>
              <div className="col-4">
                <label htmlFor="uploadPhoto" className="form-group">
                  Upload Photo
                </label>
                <input
                  type="file"
                  id="uploadPhoto"
                  className="form-control"
                  accept="image/*"
                  multiple
                />
              </div>
              <div className="col-4 d-flex align-items-end">
                <Typography
                  variant="button"
                  className="primary-btn btn col-6"
                  id="btn"
                >
                  {t("Upload")}
                </Typography>
              </div>
            </div>
          </form>
        )}
        <div className="card my-5">
          <div className="m-3">
            <h5 className="">{t("Drawing Competition ")}</h5>
            <hr />
          </div>
          <div className="row m-1">
            {imgArr.map((img, index) => (
              <div
                key={index}
                className="col-3 mb-4"
                style={{ height: "16rem", overflow: "hidden" }}
              >
                <img
                  className="col-12"
                  src={img}
                  alt={`Image ${index + 1}`}
                  style={{ height: "100%", width: "100%", objectFit: "cover" }}
                  onClick={() => openModal(img)}
                />
              </div>
            ))}
          </div>
          <Modal
            open={isModalOpen}
            onClose={closeModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Box
              sx={{
                position: "absolute",
                width: "auto",
                height:"80vh",
                bgcolor: "background.paper",
                border: "2px solid #000",
                boxShadow: 24,
                p: 4,
                overflow: "auto",
              }}
            >
              <IconButton
                aria-label="close"
                onClick={closeModal}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "black",
                }}
              >
                <CloseIcon />
              </IconButton>
              <Typography id="modal-modal-title" variant="h6" component="h2" sx={{marginBottom:"2rem"}}>
              Drawing Competition
              </Typography>
              {currentImg && (
                <img
                  src={currentImg}
                  alt="Selected"
                  style={{ height: "75%" }}
                />
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button color="secondary" onClick={closeModal}>
                  Close
                </Button>
              </Box>
            </Box>
          </Modal>
        </div>
      </div>
    </div>
  );
};

export default PhotoGallery;
